@if (showWebcam && !webcamImage) {
  <div class="full-height gray-font-color font-family">
    <div fxFlex>
      <div class="webcam-container">
        <webcam [height]="height" [width]="width" [trigger]="triggerObservable" (imageCapture)="onImageCapture($event)"
          [allowCameraSwitch]="allowCameraSwitch" [switchCamera]="nextWebcamObservable"
          [imageQuality]="1"
          (cameraSwitched)="onCameraSwitched($event)"
          (initError)="onInitError($event)">
        </webcam>
        <button mat-icon-button (click)="onTriggerSnapshot();">
          <mat-icon aria-label="Take photo button">camera</mat-icon>
        </button>
      </div>
    </div>
    @if (!isSelfieImage) {
      <div class="frame-msg-container center bottom-navigation">
        <h2>Make sure that the full document is in frame.</h2>
      </div>
    }
  </div>
}
@if (webcamImage) {
  <div class="full-height gray-font-color font-family">
    <div fxFlex>
      <div class="screenshot-container center">
        <img [width]="width" [src]="webcamImage.imageAsDataUrl"/>
      </div>
    </div>
    <div class="actions center bottom-navigation">
      <button class="half-width" mat-raised-button (click)="onRetryImage();">Retry</button>
      <button class="half-width" mat-raised-button color="primary" (click)="onSaveImage();">Ok</button>
    </div>
  </div>
}